import React from 'react';
import UniversityDetails from '../components/UniversityDetails/UniversityDetails';
import RelatedUniversity from '../components/RelatedUniversity/RelatedUniversity';

const UniversityDetailPage = () => {
  return (
    <>
      <UniversityDetails />
      <RelatedUniversity />
    </>
  );
};

export default UniversityDetailPage;
